export const FITTERSLOCATOR_LOADING = 'FITTERSLOCATOR_LOADING';
export const GET_FITTERS = 'GET_FITTERS';
export const GET_FITTER_MARKERS = 'GET_FITTER_MARKERS';
export const CURRENT_MARKER = 'CURRENT_MARKER';
export const GET_CURRENT_LOCATION = 'GET_CURRENT_LOCATION';

export const INIT_STATE = {
	fitters: [],
    markers: [],
    marker: {},
    location: {}
}


// WEBPACK FOOTER //
// ./src/fitters-locator/constants/index.js